// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-switch-checkbox {
  height: 0;
  width: 0;
  visibility: hidden;
  width: fit-content !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
}

.react-switch-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 40px;
  height: 20px;
  background: grey;
  border-radius: 20px;
  position: relative;
  transition: background-color 0.2s;
}

.react-switch-label .react-switch-button {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 16px;
  transition: 0.2s;
  background: #fff;
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
}

.react-switch-checkbox:checked + .react-switch-label .react-switch-button {
  left: calc(100% - 18px);
  transform: translateX(0);
}

.react-switch-label:active .react-switch-button {
  width: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/composants/Switch/Switch.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb","sourcesContent":[".react-switch-checkbox {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n  width: fit-content !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n}\n\n.react-switch-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  width: 40px;\n  height: 20px;\n  background: grey;\n  border-radius: 20px;\n  position: relative;\n  transition: background-color 0.2s;\n}\n\n.react-switch-label .react-switch-button {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  border-radius: 16px;\n  transition: 0.2s;\n  background: #fff;\n  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);\n}\n\n.react-switch-checkbox:checked + .react-switch-label .react-switch-button {\n  left: calc(100% - 18px);\n  transform: translateX(0);\n}\n\n.react-switch-label:active .react-switch-button {\n  width: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
